(function (angular) {
    'use strict';

    angular.module('dashboard')
        /**
         *
         */
        .controller('DashboardCtrl',
            ['$q', '$scope', '$state', 'apiSpacePicker', 'blogService', 'liveChatService', 'teamSettingsService', 'jwtService', 'usersService', 'dashboardMessageDataService', 'permissionService',
                function ($q, $scope, $state, apiSpacePicker, blogService, liveChatService, teamSettingsService, jwtService, usersService, dashboardMessageDataService, permissionService) {

                    $scope.hasAnalyticsPermission = permissionService.checkPermission("anlyt:ro") && permissionService.checkPermission("chat:cfg:r");

                    // // check user has analytics permission
                    // if (!permissionService.checkPermission("anlyt:ro")) {

                    //     // if has contact, go to chat
                    //     if (permissionService.checkPermission("package:contact")) {
                    //         $state.go("main.apiSpace.chat2.chat");
                    //     } else {
                    //         // go to profiles
                    //         $state.go("main.apiSpace.profiles.search");
                    //     }

                    //     return;
                    // }

                    $scope.initialised = false;

                    $scope.$on("apiSpacesUpdate:picked", function () {
                        if ($scope.hasAnalyticsPermission) {
                            initialiseAnalytics();
                        }
                    })
                    $scope.$on("$destroy", function () {
                        if ($scope.initialised) {
                            liveChatService.uninitialise();
                        }
                    });

                    function resolveOnNotFound(result) {
                        return result.then(function (r) {
                            return $q.resolve(r);
                        }).catch(function (e) {
                            if (e.status === 404) {
                                return $q.resolve({});
                            } else {
                                return $q.reject(e);
                            }
                        })
                    }

                    function initialiseAnalytics() {
                        var _config;
                        var _users;
                        var pickedApiSpaceId;
                        var pickedApiSpace = apiSpacePicker.getPickedApiSpace();

                        if (pickedApiSpace) {
                            pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;
                            return usersService.getUsers(jwtService.payload.accountId)
                                .then(function (users) {
                                    _users = users;
                                    return resolveOnNotFound(teamSettingsService.getChatConfig(pickedApiSpaceId));
                                })
                                .then(function (config) {
                                    _config = config;
                                    return resolveOnNotFound(teamSettingsService.getTeams(pickedApiSpaceId));
                                })
                                .then(function (result) {
                                    $scope.teams = result;

                                    if (_config.teams) {
                                        $scope.teams.forEach(function (team) {
                                            var ct = _config.teams.find(function (t) {
                                                return t.teamId === team.id;
                                            });
                                            team.channels = ct ? ct.channels : {};
                                        });
                                    }

                                    if ($scope.teams.length) {
                                        liveChatService.initialise($scope.teams, undefined, _users, {
                                            timeline: false,
                                            channelSpread: false,
                                            team: true
                                        });
                                    }

                                    return dashboardMessageDataService.getMessageData();
                                })
                                .then(function (data) {
                                    $scope.lineData = data.line;
                                    $scope.barData = data.bar;
                                    $scope.initialised = true;
                                    return true;
                                });
                        }
                    }

                    if ($scope.hasAnalyticsPermission) {
                        initialiseAnalytics();
                    }

                    blogService.getFeed()
                        .then(function (blogs) {
                            $scope.blogs = blogs;
                        });
                }]);

})(window.angular);
